import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const themeColor = "#245CA6";
const themeLightColor = "#69b7ff1a";
const whiteColor = "#ffffff";
const drawerWidth = 62;
const textTransform1 = "capitalize";
const font_family =
  // '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
  '"Lato","Nunito","Segoe UI", sans-serif';
const mobileFontFamily = '"Nunito","Segoe UI", sans-serif';

const baseTheme = createTheme({
  palette: {
    primary: {
      main: themeColor,
      light: themeLightColor,
    },
    secondary: {
      main: "#E12027", // red color
    },
    error: {
      main: "#D32F2F",
    },
    warning: {
      main: "#FBC02D",
    },
    info: {
      main: "#0288D1",
    },
    success: {
      main: "#689F38",
    },
  },
  typography: {
    body1: {
      fontFamily: font_family,
      color: "#293241cc",
      fontSize: "16px",
      fontWeight: 400,
      margin: "0",
      padding: "0",
    },
    body2: {
      margin: "5px",
      fontFamily: font_family,
      fontSize: "12px",
      fontWeight: 600,
    },
    h1: {
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "26px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    h2: {
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "24px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    h3: {
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "22px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "13px",
      },
    },
    h4: {
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "20px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    h5: {
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "18px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    h6: {
      textTransform: textTransform1,
      margin: "15px 0 0.5rem 0",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "16px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    subtitle2: {
      marginLeft: "5px",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "14px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
    subtitle1: {
      fontWeight: 400,
      lineHeight: 1.2,
      color: "inherit",
      fontSize: "14px",
      fontFamily: font_family,
      "&:first-child": {
        marginTop: "0px",
      },
    },
  },
  shape: {
    borderRadius: 4,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 768,
      lg: 991,
      xl: 1200,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          maxHeight: "100vh",
          overflowY: "hidden",
        },
      },
    },
    MuiAppBar: {
      defaultProps: {
        sx: {
          minHeight: drawerWidth,
          background: whiteColor,
          position: "fixed",
          zIndex: 999,
          boxShadow: "0 10px 40px 0 rgb(41 50 65 / 6%)",
          color: "#293241",
        },
      },
      styleOverrides: {
        root: {
          "&.exp-panel-org-desktop-smaller-logo": {
            width: "73px !important",
            height: "10px !important",
          },
        },
      },
    },
    MuiListItemIcon: {
      defaultProps: {
        sx: {
          color: "#293241",
          minWidth: "32px",
          fontSize: "26px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: whiteColor,
          // margin: '3px',
          "& .MuiBox-root": {},
          "& .mui-table-title": {
            marginBottom: "18px",
            fontFamily: "inherit",
            fontWeight: "600",
            fontSize: "1.25rem",
          },
          "& .MuiTabPanel-root": {
            padding: "0px",
            background: "#ffffff",
            margin: "0px 5px",
            borderRadius: "10px",
          },
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiListItem: {
      defaultProps: {
        sx: {
          padding: "5px 0px",
          height: "55px",
        },
      },
      styleOverrides: {
        root: {
          paddingTop: "16px",
          "&.block-type-list-item": {
            margin: "10px 0px",
            borderLeft: "4px solid green",
            boxShadow: "0px 1px 15px 3px #ccc",
            borderRadius: "5px",
            backgroundColor: "#fff",
            height: "70px",
            minWidth: "991px",
          },
          "& :hover": {
            color: themeColor,
            "& .MuiListItemIcon-root": {
              color: themeColor,
            },
          },
          "&.left-menu-item": {
            color: themeColor,
            "&:before": {
              content: '""',
              backgroundColor: themeColor,
              width: "4px",
              height: "12px",
              display: "block",
              borderRadius: "0px 3px 3px 0px",
              position: "absolute",
            },
            "& .MuiListItemIcon-root": {
              color: themeColor,
            },
            "&.Mui-selected": {
              backgroundColor: whiteColor + " !important",
              color: themeColor + " !important",
              "& .MuiSvgIcon-root": {
                color: themeColor + " !important",
              },
              "& .MuiTypography-root": {
                color: themeColor,
              },
            },
          },
        },
      },
    },
    MuiAvatar: {
      defaultProps: {
        sx: {
          width: "10%",
          height: "100%",
        },
      },
      styleOverrides: {
        root: {},
      },
    },
    MuiToolbar: {
      defaultProps: {
        sx: {
          minHeight: drawerWidth,
          "& .horizontal-menu": {
            marginTop: "5px",
            marginLeft: "10px",
            "& .MuiButton-root": {
              color: "#293241",
            },
            "& .horizontal-menu-btn": {
              marginRight: "0px !important",
            },
            "& .horizontal-menu-btn.selected-menu": {
              color: themeColor,
            },
            "& .horizontal-menu-btn:hover": {
              backgroundColor: themeLightColor,
            },
          },
          "@media screen and (max-width: 991px)": {
            "& .horizontal-menu": {
              display: "none",
            },
          },
          "@media screen and (min-width: 575px)": {
            paddingLeft: "10px",
            paddingRight: "10px",
          },
          "@media screen and (max-width: 575px)": {
            paddingLeft: "10px",
            paddingRight: "10px",
          },
        },
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        sx: {
          fontSize: 30,
        },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        sx: {
          "& .theme-menu": {
            width: "26px",
            height: "26px",
            borderRadius: "26px",
            display: "block",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.2s",
            boxShadow: "0 0.125rem 0.25rem rgb(0 0 0 / 8%)",
            marginRight: "5px",
          },
          "&.menu-mode": {
            //padding: '5px 5px',
            marginLeft: "5%",
          },
          "&.horizontal-menu-dropdown-list": {
            padding: "0px 10px 0px 0px",
            margin: "0px 10px 5px 10px",
            borderRadius: "8px",
          },
          "&.horizontal-menu-dropdown-list.selected-menu": {
            color: themeColor,
            background: themeLightColor,
            "& .horizontal-menu-dropdown-list-icon": {
              color: themeColor,
            },
          },
          "&.horizontal-menu-dropdown-list:hover": {
            background: themeLightColor,
          },
          "& .horizontal-menu-dropdown-list-icon": {
            fontSize: "26px",
            color: "#92969e",
            margin: "5px 0px 5px 5px",
          },
          "& .default-theme": {
            backgroundColor: themeColor,
          },
        },
      },
      styleOverrides: {
        root: {
          // color: '#92969e',
          "& .MuiSvgIcon-root": {
            fontSize: 18,
            // color: themeColor,
          },
          "& .MuiListItemIcon-root": {
            minWidth: "25px",
          },
          "&.left-submenu-1": {
            // paddingLeft: '23px',
            margin: "0px 15px",
            top: "-5px",
            color: "#92969e",
          },
          "&.left-submenu-2": {
            margin: "0px 15px",
            color: themeColor,
            "& .MuiListItemIcon-root": {
              color: themeColor,
            },
            "&:hover": {
              borderRadius: "11px",
              backgroundColor: themeLightColor,
              "& .MuiListItemIcon-root": {
                color: themeColor,
              },
            },
          },
          "& .mobile-more-list": {
            color: "#000000de",
            fontSize: "24px",
          },
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          "& .MuiStack-root": {
            padding: "0px",
            width: "108%",
            "& .MuiInputBase-root": {
              "& .MuiInputBase-input": {
                padding: "8.5px 8px",
              },
            },
          },
          "& .MuiFormControlLabel-root": {
            "& .MuiTypography-root": {
              fontSize: "1em",
              marginTop: "0.6em",
            },
          },
          "&.mobile-view-component": {
            width: "100%",
            minHeight: "90vh",
            padding: "32px 0px",
            backgroundColor: "#eef0f2",
          },
          "&.desktop-view-horizontal-menu-component": {
            minHeight: "90vh",
            width: "100%",
            padding: "30px 0px",
            marginLeft: "0px",
            backgroundColor: "#eef0f2",
          },
          "&.desktop-view-verticle-menu-component": {
            minHeight: "90vh",
            width: `calc(100% - ` + drawerWidth + `px)`,
            padding: "30px 0px",
            marginLeft: drawerWidth + "px",
            backgroundColor: "#eef0f2",
          },
          "@media screen and (max-width: 991px)": {
            "&.desktop-view-verticle-menu-component": {
              width: "100%",
              marginLeft: "0px",
            },
            "&.horizontal-menu": {
              display: "none",
            },
          },
          "@media screen and (min-width: 991px)": {
            "&.mobile-view-component": {
              width: `calc(100% - ${drawerWidth}px)`,
              marginLeft: drawerWidth,
            },
          },
          "&.desktop-view-verticle-menu-component > :first-child": {
            marginTop: "40px",
            marginLeft: "5px",
          },
          "&.desktop-view-horizontal-menu-component > :first-child": {
            marginTop: "40px",
            marginLeft: "5px",
          },
          "&.mobile-view-component > :first-child": {
            marginTop: "40px",
            marginLeft: "5px",
          },
          "& .rating-block": {
            "& .MuiSvgIcon-root": {
              width: "22px",
            },
          },
          "& .not-interested-icon": {
            color: "#ff000099",
          },
          "& .react-dropdown-tree-select .dropdown": {
            width: "98%",
          },
          "& .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow": {
            width: "100%",
          },

          "& .tag-item:last-child": {
            width: "96%",
          },

          "& .tag-item .search": {
            borderBottom: "0px !important",
          },
          "& .tag": {
            borderRadius: "15px !important",
            backgroundColor: themeColor + " !important",
            padding: "5px 5px 5px 10px !important",
            color: "white !important",
          },
          "& .react-dropdown-tree-select .dropdown .dropdown-trigger": {
            borderRadius: "5px",
          },
          "& .toggle:focus": {
            outline: "0px",
          },
          "& .react-dropdown-tree-select .dropdown .dropdown-content": {
            width: "100%",
          },
          "& .tag-remove": {
            color: "white",
            fontSize: "100%",
          },
          "& .react-dropdown-tree-select .dropdown .dropdown-trigger:focus": {
            outline: "0px",
          },
          '& input[type="checkbox"]:checked': {
            backgroundColor: "white",
            borderColor: "white",
          },
          

          
          '& input[type="checkbox"]:checked:after': {
            width: "2px !important",
            height: "9px !important",
            border: "solid " + themeColor,
            borderWidth: "0 2px 2px 0",
            transform: "rotate(45deg)",
            content: '""',
            position: "absolute",
            marginLeft: "4px",
          },
          '& input[type="checkbox"]': {
            appearance: "none",
            width: "14px",
            height: "14px",
            border: "1px solid black",
          },
          '& input[type="checkbox"]:focus': {
            outline: "0px",
          },
          "& .node.checked": {
            backgroundColor: themeColor,
            color: "white",
          },
          "& .node>label": {
            fontFamily: font_family,
          },
          "&.data-grid-pro": {
            height: "90vh",
            width: "100%",
          },
          "&.user-edit-grid": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            "& .button-icon": {
              marginLeft: "10px",
            },
            "& .refresh-button": {
              backgroundColor: "#000000",
            },
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        sx: {
          width: "100%",
          borderRadius: "6px",
        },
      },
      styleOverrides: {
        root: {
          margin: "12px 9px 0px 9px ",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            fontSize: "25px",
          },
          "& .PrivateSwitchBase-input+span": {
            width: "20px",
            height: "20px",
          },
          "&.Mui-checked": {
            "& span": {
              backgroundColor: themeColor,
            },
            "& span:before": {
              display: "block",
              width: "18.4px",
              height: "18px",
              backgroundImage:
                "radial-gradient(" +
                whiteColor +
                "," +
                whiteColor +
                " 42%,transparent 47%)",
              content: '""',
              backgroundPositionX: ".8px",
              backgroundPositionY: "1px",
            },
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "100%",
          "& .MuiFormControlLabel-root": {
            marginLeft: "0px",
          },
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        sx: {
          color: themeColor,
          borderRadius: "6px",
        },
      },
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-fontSizeSmall": {
            width: "25px",
            height: "25px",
            borderRadius: "6px",
          },
          "&.Mui-checked": {
            color: themeColor,
          },
        },
      },
    },
    MuiSwitch: {
      defaultProps: {
        sx: {
          margin: "12px 0px 0px 9px",
        },
      },
      styleOverrides: {
        root: {
          "& .Mui-checked": {
            color: themeColor + " !important",
          },
          "& .Mui-checked+.MuiSwitch-track": {
            backgroundColor: themeColor + " !important",
          },
        },
      },
    },

    MuiList: {
      styleOverrides: {
        root: {
          "&.block-type-list": {
            backgroundColor: "#eef0f2",
            paddingTop: "0px",
            minWidth: "991px",
          },
          "& .Mui-selected": {
            backgroundColor: themeColor + " !important",
            color: whiteColor + " !important",
            "& .MuiSvgIcon-root": {
              color: whiteColor + " !important",
            },
            "& .MuiTypography-root": {
              color: whiteColor,
            },
          },
          "& .MuiCheckbox-root": {
            padding: "0px 5px 0px 0px",
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: themeColor,
          "& .MuiSlider-rail": {
            color: themeColor,
          },
        },
      },
    },
    MuiRating: {
      defaultProps: {
        sx: {
          color: themeColor,
        },
      },
    },
    MuiToggleButton: {
      defaultProps: {
        sx: {
          textTransform: textTransform1,
        },
      },
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: themeColor + " !important",
            color: whiteColor,
          },
          "&.single-toggle-btn": {
            width: "100%",
            padding: "3px",
          },
        },
      },
    },
    MuiChip: {
      defaultProps: {
        sx: {
          backgroundColor: themeColor,
          color: whiteColor,
        },
      },
      styleOverrides: {
        root: {
          "&.MuiChip-filledSuccess": {
            backgroundColor: "#C8E6C9",
            color: "#256029",
          },
          "&.MuiChip-filledWarning": {
            backgroundColor: "#FEEDAF",
            color: "#8a5340",
          },
          "&.MuiChip-filledInfo": {
            backgroundColor: "#ECCFFF",
            color: "#694382",
          },
          "&.MuiChip-filledError": {
            backgroundColor: "#FFCDD2;",
            color: "#c63737",
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        sx: {
          padding: "7px 14px",
          fontFamily: font_family,
          marginRight: ".5rem!important",
          marginBottom: ".5rem!important",
          textTransform: textTransform1,
          borderRadius: "6px",
          lineHeight: "normal",
          fontWeight: "400",
          boxShadow: "0 0 0 0 " + whiteColor,
          "&.MuiButton-containedPrimary": {
            color: whiteColor,
          },
          "&.Mui-disabled": {
            color: "#fff",
            boxShadow: "none",
            opacity: 0.6,
            backgroundColor: themeColor,
          },
        },
      },
      styleOverrides: {
        root: {
          "&.icon-btn": {
            minWidth: "30px",
            padding: "6px",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "20px",
          },
          "&.rounded-btn": {
            borderRadius: "20px",
          },
          "&.rounded-btn-icons": {
            minWidth: "2rem",
            borderRadius: "50%",
            padding: "6px",
          },
          "& .MuiCircularProgress-root": {
            color: "#fff !important",
          },
        },
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        sx: {
          boxShadow: "0 0 0 0 " + whiteColor,
          "& .MuiButton-root": {
            marginRight: "0rem!important",
            marginBottom: "0rem!important",
          },
          "&.MuiButtonGroup-root .MuiButtonGroup-grouped:not(:last-of-type)": {
            borderRight: "0px solid #bdbdbd",
          },
          "&.split-btn-grp": {
            marginRight: "0.5rem!important",
            marginBottom: "0.5rem!important",
            "& .split-btn-grp-btn": {
              minWidth: "30px",
              padding: 0,
            },
          },
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        // sx: {
        //   "& .MuiSvgIcon-root": {
        //     fontSize: "20px",
        //   },
        // },
      },
      styleOverrides: {
        root: {
          "&.MuiIconButton-root": {
            // backgroundColor: themeColor,
            color: themeColor,
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          // "& .MuiPaginationItem-circulared.Mui-selected": {
          //   color: whiteColor,
          // },
          "& .Mui-selected": {
            backgroundColor: themeColor + " !important",
            color: whiteColor,
          },
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        sx: {
          minHeight: "36px",
          "& .MuiTabs-scrollButtons.Mui-disabled": {
            display: "none",
          },
          "& .MuiTabs-indicator": {
            color: themeColor,
          },
        },
      },
    },
    MuiTab: {
      defaultProps: {
        sx: {
          minHeight: "48px",
          minWidth: `calc(100%/4)`,
          textTransform: textTransform1 + " !important",
          "& .MuiSvgIcon-root": {
            fontSize: "20px",
          },
        },
      },
      styleOverrides: {
        root: {
          fontFamily: font_family,
          fontWeight: 800,
        },
      },
    },
  },
});

// const {
//   breakpoints,
//   typography: { pxToRem },
// } = defaultTheme;

// const baseTheme = {
//   ...defaultTheme,
//   overrides: {
//     MuiTypography: {
//       h1: {
//         fontFamily: font_family,
//         [breakpoints.down("sm")]: {
//           fontFamily: mobileFontFamily,
//         },
//       },
//       body1: {
//         fontFamily: font_family,
//         [breakpoints.down("sm")]: {
//           fontFamily: mobileFontFamily,
//         },
//       },
//     },
//   },
// };

export default baseTheme;
